import React from "react";
import Image from "../../elements/Image";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Autoplay } from "swiper/modules";
import BackgroundImage from "../../../assets/images/bg.webp";
import { useTranslation } from "react-i18next";

const EventBanner = ({ event = {}, title = "DANCE EVENTS" }) => {
  const { t } = useTranslation();
  const images = Array.isArray(event?.gallery)
    ? event.gallery.map((img) => img?.url).filter(Boolean)
    : [];

  const hasMultipleImages = images.length > 1;
  const hasSingleImage = images.length === 1;

  return (
    <section className="relative h-[650px] bg-white z-[0] flex flex-col items-end justify-end px-5 xl:px-auto">
      {hasMultipleImages ? (
        <div className="absolute left-0 top-0 w-full h-full overflow-hidden">
          <Swiper
            autoplay={{ delay: 3000, disableOnInteraction: false }}
            loop
            modules={[Autoplay]}
            className="eventDetailsSlider"
          >
            {images.map((img, index) => (
              <SwiperSlide key={index}>
                <div className="w-full h-full">
                  <Image src={img} classes="w-full h-full object-cover" />
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      ) : hasSingleImage ? (
        <div className="absolute left-0 top-0 w-full h-full">
          <Image src={images[0]} classes="w-full h-full object-cover" />
        </div>
      ) : (
        <div className="absolute left-0 top-0 w-full h-full">
          <Image src={BackgroundImage} classes="w-full h-full object-cover" />
        </div>
      )}

      {/* Overlay */}
      <div className="absolute left-0 top-0 w-full h-full bg-gradient-to-t from-[#151515] via-[#434343]/50 to-white/0 z-[1]"></div>

      <div className="max-w-7xl 2xl:max-w-8xl 3xl:max-w-9xl w-full mx-auto relative z-[2] space-y-10">
        <nav className="relative">
          <ul className="flex flex-wrap items-center text-2xl md:text-3xl">
            <li className="flex items-center">
              <Link
                to="#"
                className="text-white hover:text-primary uppercase font-semibold"
              >
                {t("Home")}
              </Link>
              <span className="mx-2 text-white">/</span>
            </li>
            <li className="flex items-center">
              <Link
                to="#"
                className="text-white hover:text-primary uppercase font-semibold"
              >
                {t("Events")}
              </Link>
            </li>
          </ul>
        </nav>
        <h1 className="uppercase text-white font-extrabold text-5xl md:text-6xl lg:text-7xl xl:text-8xl 2xl:text-[120px] leading-[60px] md:leading-[95px] tracking-wider">
          {t(title)}
        </h1>
      </div>
    </section>
  );
};

export default EventBanner;
